<template>
  <a-box>
    <l-rows>
      <a-title
        v-if="!titleHidden"
        :size="4"
        :text="$t('casinos.options')"
      />
      <a-checkbox
        :value="value && value.showDevelopStartPage"
        :text="this.$t('casinos.showDevelopStartPage')"
        fullwidth
        :disabled="disabled"
        @input="handleShowDevelopStartPageInput"
      />
      <a-checkbox
        :value="value && value.sendEventMessages"
        :text="this.$t('casinos.sendEventMessages')"
        fullwidth
        :disabled="disabled"
        @input="handleSendEventMessagesInput"
      />
    </l-rows>
  </a-box>
</template>

<script>
  import { ABox, ACheckbox, ATitle, LRows } from 'codefabrik-gui-vue'

  export default {
    name: 'CasinoOptionsConfiguration',
    components: { ACheckbox, LRows, ABox, ATitle },
    props: {
      value: {
        type: Object,
        default: () => ({
          showDevelopStartPage: false,
          sendEventMessages: true
        })
      },
      disabled: {
        type: Boolean
      },
      titleHidden: {
        type: Boolean
      }
    },
    methods: {
      handleShowDevelopStartPageInput (value) {
        this.$emit('input', {
          ...this.value,
          showDevelopStartPage: value
        })
      },
      handleSendEventMessagesInput (value) {
        this.$emit('input', {
          ...this.value,
          sendEventMessages: value
        })
      },
    }
  }
</script>

<style scoped>

</style>
